import { createSlice } from "@reduxjs/toolkit";

interface initialState {
  viewModal: boolean;
  setRemarks: string;
  setTimer: boolean;
  statusError: any[];
  successMessage: boolean;
  successLabel: string;
  errorMessage: boolean;
  errorLabel: string;
  errorMessageList: string[];
  deletedIds: string[];
}

const INIT_STATE: initialState = {
  viewModal: false,
  setRemarks: "",
  setTimer: false,
  statusError: [],
  successLabel: "",
  successMessage: false,
  errorLabel: "",
  errorMessage: false,
  errorMessageList: [],
  deletedIds: []
};

export const ActionButtonSlice = createSlice({
  name: "ActionButtonSlice",
  initialState: INIT_STATE,
  reducers: {
    setDeleteContentData: (state, action) => {
      return {
        ...state,
        ...action.payload
      };
    },

    setStatus: (state, action) => {
      return {
        ...state,
        ...action.payload
      };
    },

    setStatusError: (state, action) => {
      return {
        ...state,
        ...action.payload
      };
    },

    setSuccessMessage: (state, action) => {
      return {
        ...state,
        ...action.payload
      };
    },

    setErrorMessage: (state, action) => {
      return {
        ...state,
        ...action.payload
      };
    },

    setDeletedIds: (state, action) => {
      state.deletedIds.push(action.payload);
    },

    resetToastMessage: (state) => {
      state.errorMessage = false;
      state.errorLabel = "";
      state.successLabel = "";
      state.successMessage = false;
      state.errorMessageList = [];
    },

    resetData: (state) => {
      return {
        ...INIT_STATE,
        successMessage: state?.successMessage || false,
        successLabel: state?.successLabel || "",
        errorMessage: state?.errorMessage || false,
        errorLabel: state?.errorLabel || "",
        errorMessageList: state?.errorMessageList || [],
        deletedIds: state?.deletedIds || []
      };
    }
  }
});
